import styled from "styled-components";
import { css } from "@styled-system/css";
import { themeGet } from "@styled-system/theme-get";
import { applySmallScreenObject } from "./smallScreen";

const BADGE_CLASS = ".pane-edge-handle-badge";

export const HandleTrack = styled("div")((props) =>
  css({
    position: "absolute",
    top: "0",
    bottom: "0",
    width: "13px",
    padding: "0 5px",
    backgroundClip: "content-box",
    height: "100%",
    zIndex: "100",
    cursor: "col-resize",
    backgroundColor: "transparent",
    border: "none",
    appearance: "none",
    fontFamily: themeGet("fonts.main")(props),
    outline: "none",
    transition: themeGet("transition.transitionDefault")(props),
    ...(props.$edge === "start"
      ? { left: "-8px", right: "auto" }
      : { right: "-8px", left: "auto" }),
    "&:hover, &:focus-visible": {
      backgroundColor: themeGet("colors.primaryLighter")(props),
      [BADGE_CLASS]: {
        backgroundColor: themeGet("colors.primaryLighter")(props),
        opacity: "1",
      },
    },
    "&:active": {
      backgroundColor: themeGet("colors.primaryLight")(props),
      [BADGE_CLASS]: {
        backgroundColor: themeGet("colors.primaryLight")(props),
      },
    },
    ...applySmallScreenObject(props, {
      right: "0",
      top: "-8px",
      left: "0",
      padding: "5px 0",
      bottom: "auto",
      width: "100%",
      height: "13px",
      cursor: "row-resize",
    }),
  })
);

export const HandleBadge = styled("div")((props) =>
  css({
    position: "absolute",
    opacity: "0",
    top: "20px",
    left: "50%",
    height: "28px",
    width: "28px",
    backgroundColor: themeGet("colors.white")(props),
    borderRadius: themeGet("radii.2")(props),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: themeGet("colors.white")(props),
    transform: "translateX(-50%)",
    transition: themeGet("transition.transitionDefault")(props),
    boxShadow: themeGet("shadows.boxDefault")(props),
    pointerEvents: "none",
    svg: {
      color: themeGet("colors.white")(props),
    },
    ...applySmallScreenObject(props, {
      left: "50%",
      top: "6px",
      flexDirection: "column",
      transform: "translate(-50%, -50%)",
      width: "93px",
      borderRadius: "0 0 2px 2px",
      height: "15px",
      "& > span": {
        height: "6px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
    }),
  })
);
